import { backendFetch } from '../apiUtils';
import { downloadJsonFile } from '../newLoad';

export const getNewLoadNeeNorDropdownV2 = async ({ id, type, skip = 0, rpaID = '', search = '', isEPO = false }) => {
  const referenceDataResponse = await backendFetch({
    url: `v2/newLoad/neenor`,
    params: { id, type, search, rpaID: rpaID ?? '', skip: skip ?? 0, isEPO },
  });

  return referenceDataResponse.data;
};

export const getCustomerList = async () => {
  const referenceDataResponse = await backendFetch({
    url: `v2/newLoad/nbpList`,
  });

  return referenceDataResponse.data;
};

export const getReferenceData = async () => {
  const referenceDataResponse = await backendFetch({
    url: 'v2/newLoad/referenceData',
  });

  return referenceDataResponse.data;
};

export const getReferenceDataByDirection = async (directionId) => {
  const referenceDataResponse = await backendFetch({
    url: 'v2/newLoad/referenceDataByDirection',
    params: { directionId },
  });

  return referenceDataResponse.data;
};

export const getLoadStatus = async (loadId) => {
  return await backendFetch({
    url: `v2/listload/status`,
    method: 'GET',
    params: { id: loadId },
  });
};

export const getDocumentTypes = async () => {
  const documentResponse = await backendFetch({
    url: 'v2/newLoad/documents/types',
  });

  return documentResponse.data;
};

export const getDocumentsForLoad = async (newLoadId) => {
  const documentResponse = await backendFetch({
    url: 'v2/newLoad/documents',
    params: { newLoadId },
  });

  return documentResponse.data;
};

export const getDocumentById = async (id) => {
  const documentResponse = await backendFetch({
    url: 'v2/newLoad/documents/open',
    params: { id },
    isReporting: true,
  });

  return documentResponse;
};

export const updateDocumentDetails = async ({ id, invoiceNumber = '', documentType = '', cm8 = false }) => {
  const documentResponse = await backendFetch({
    url: 'v2/newLoad/documents',
    options: {
      body: JSON.stringify({ id, invoiceNumber, documentType, cm8 }),
      headers: { 'Content-Type': 'application/json' },
    },
    method: 'PUT',
  });

  return documentResponse.success;
};

export const deleteDocumentById = async (id) => {
  const documentResponse = await backendFetch({
    url: 'v2/newLoad/documents',
    params: { id },
    method: 'DELETE',
  });

  return documentResponse.data;
};

export const restoreDocumentById = async (id) => {
  const documentResponse = await backendFetch({
    url: 'v2/newLoad/documents/restore',
    params: { id },
    method: 'PUT',
  });

  return documentResponse.data;
};

export const uploadDocumentToLoad = async (formData) => {
  const documentResponse = await backendFetch({
    url: 'v2/newLoad/documents/upload',
    options: { body: formData },
    method: 'POST',
  });

  return documentResponse.data;
};

export const processRpaForLoad = async ({ fileId, filename }) => {
  const urls = {
    csv: 'v2/fileupload/csv',
    xls: 'v2/fileupload/xls',
    xlsx: 'v2/fileupload/xls',
    xml: 'v2/fileupload/xml',
    json: 'v2/fileupload/json',
  };

  const url = urls[String(filename).toLowerCase().split('.').slice(-1)];

  const formData = new FormData();
  formData.append('ids', [fileId]);

  return await backendFetch({
    url,
    method: 'POST',
    options: { body: formData },
  });
};

export const sendDocumentsToCustomaite = async (data) => {
  const response = await backendFetch({
    url: 'v2/customaite/createNewDossier',
    method: 'POST',
    options: { body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } },
  });

  if (!response.success) {
    throw new Error(JSON.stringify(response.errors));
  }

  return response;
};

export const updateDossierStatus = async (data) => {
  const response = await backendFetch({
    url: 'v2/customaite/updateDossierStatus',
    method: 'POST',
    options: { body: data },
  });

  if (!response.success) {
    throw new Error(JSON.stringify(response.errors));
  }

  return response.data;
};

export const getNewUnifiedLoad = async (loadId) => {
  return await backendFetch({
    url: 'v2/newload/viewload',
    method: 'GET',
    params: { id: loadId },
    authorised: true,
  });
};

export const downloadUnifiedDataFile = async ({ loadId, fileName, origin, hsCodes = [] }) => {
  const data = await backendFetch({
    url: 'v2/newload/downloadFile',
    method: 'GET',
    params: { id: loadId, origin, hscode: hsCodes.join(',') },
    authorised: true,
  });

  const isIpaffsExport = Boolean(origin && hsCodes.length > 0);
  const exportData = isIpaffsExport ? (({ customer, parent, ...rest }) => rest)(data) : data;

  downloadJsonFile({ data: exportData, fileName });
};

export const postUnifiedLoadLazyLoad = async (payload) => {
  const response = await backendFetch({
    url: 'v2/newload/lazyLoad',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
    },
    authorised: true,
  });

  if (response?.success === false) {
    throw new Error(response.message || 'Failed to load unified CABIE loads.');
  }

  return response.data;
};

export const saveLoad = async (load) => {
  const documentResponse = await backendFetch({
    url: 'v2/newload/save',
    options: { body: JSON.stringify(load), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
  let fileUploadSuccess;
  if (documentResponse?.data?.[0]?.id && load.importFile) {
    // If the load has an import file, we need to upload it after saving the load
    try {
      const formData = new FormData();
      formData.append('documents', load.importFile);
      formData.append('documentNames', 'Commercial Document');
      formData.append('documentStatus', 'RPA Processed');
      formData.append('invoiceNumber', load.invoicenumber);
      formData.append('id', documentResponse?.data?.[0]?.id);
      await uploadDocumentToLoad(formData);
      fileUploadSuccess = true;
    } catch {
      fileUploadSuccess = false;
    }
  }

  return { data: documentResponse.data, fileUploadSuccess };
};

export const getCommodityDutyRates = async (items, vatAdj = null, roiLoad = null) => {
  const response = await backendFetch({
    url: 'v2/newload/commodityDutyRates',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items, vatAdjustment: vatAdj, ROILoad: roiLoad }),
    },
  });

  return Array.isArray(response) ? response : response?.data;
};

export const getOrderForms = async (loadId) => {
  const response = await backendFetch({
    url: 'v2/newload/getOrderForms',
    method: 'GET',
    params: { loadId },
  });

  return response.data;
};

export const getQaPreferences = async (newLoadId) => {
  const response = await backendFetch({
    url: 'v2/newload/qaPreferences',
    method: 'GET',
    params: { newLoadId },
  });

  return response.data;
};

export const getQaData = async (loadId) => {
  const response = await backendFetch({
    url: 'v2/newload/qadata',
    method: 'GET',
    params: { loadId },
  });

  return response.data;
};

export const getCommodityTree = async (commodityCode) => {
  const response = await backendFetch({
    url: 'v2/newload/commodityTree',
    method: 'GET',
    params: { commCode: commodityCode },
  });

  return response.data;
};

export const updateStatusViaCog = async (loadId, status) => {
  const documentResponse = await backendFetch({
    url: 'v2/newload/updateStatus',
    options: { body: JSON.stringify({ id: loadId, status }), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
  return documentResponse.data;
};

export const duplicateLoad = async (loadId) => {
  const documentResponse = await backendFetch({
    url: `v2/newload/duplicate/${loadId}`,
    options: { headers: { 'Content-Type': 'application/json' } },
    method: 'PUT',
  });
  return documentResponse.data;
};

export const getNewLoadMovement = async () => {
  const { data } = await backendFetch({
    url: 'v2/newload/movement',
    method: 'GET',
    authorised: true,
  });
  return data;
};

/** Unify V2 status list for CABIE load filters (GET /v2/newload/status). */
export const normalizeStatusListResponse = (response) => {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  return [];
};

export const getNewLoadStatuses = async () => {
  const response = await backendFetch({
    url: 'v2/newload/status',
    method: 'GET',
    authorised: true,
  });

  if (response?.success === false) {
    throw new Error(response.message || 'Failed to load statuses.');
  }

  return normalizeStatusListResponse(response);
};

export const createNewCM8Load = async (formData) => {
  const documentResponse = await backendFetch({
    url: 'v2/customaite/createNewDossier',
    options: { body: formData },
    method: 'POST',
  });

  return documentResponse.data;
};

export const validateLoad = async (load) => {
  return await backendFetch({
    url: 'v2/newload/validation',
    options: { body: JSON.stringify(load), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
};

/**
 * Preferential origin validation for QA Preference Check.
 * Endpoint: v2/newLoad/qaPrefValidation (replaces newload/qaPrefValidation)
 * Response must match v1: array of { pref, eu, thirdCountry, origin }.
 */
export const postCheckPreferentialValidation = async (items) => {
  const body = typeof items === 'string' ? items : JSON.stringify(items);
  const response = await backendFetch({
    url: 'v2/newLoad/qaPrefValidation',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body,
    },
  });

  return response?.data ?? response;
};

export const postValidateRex = async (items) => {
  const response = await backendFetch({
    url: 'v2/newload/validateRex',
    method: 'POST',
    options: {
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    },
  });

  return response.data;
};

export const fileUpload = async (fileType, formData) => {
  const documentResponse = await backendFetch({
    url: `v2/fileUpload/${fileType}`,
    options: { body: formData },
    method: 'POST',
  });
  return documentResponse.data;
};

export const amendDeclaration = async (loadId) => {
  const response = await backendFetch({
    url: 'v2/listload/amendDeclaration',
    options: { body: JSON.stringify({ id: loadId }), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });

  if (response?.success === false) {
    throw new Error(response.message || 'Error amending declaration.');
  }

  return response?.data ?? response;
};

export const updateStatus = async (loadId, status) => {
  const documentResponse = await backendFetch({
    url: `v2/newload/updateStatus/${loadId}`,
    options: {
      body: JSON.stringify({
        status,
      }),
      headers: { 'Content-Type': 'application/json' },
    },
    method: 'PUT',
  });
  return documentResponse.data;
};

export const addCommodityDescription = async (payload) => {
  const documentResponse = await backendFetch({
    url: `v2/newload/commodityDescriptions`,
    options: { body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
  return documentResponse.data;
};

export const manageComcodes = async (payload) => {
  const documentResponse = await backendFetch({
    url: `v2/newload/manageCommCode`,
    options: { body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
  return documentResponse.data;
};

export const validateComcode = async (commodityCode) => {
  const documentResponse = await backendFetch({
    url: `v2/manageCommCode/validate`,
    params: { commodityCode },
    method: 'GET',
  });
  return documentResponse.data;
};

export const mappingComcode = async (payload) => {
  const documentResponse = await backendFetch({
    url: `v2/manageCommCode`,
    options: { body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
  return documentResponse.data;
};

export const getIpaffsCategories = async () => {
  const { data } = await backendFetch({
    url: 'v2/ipaffsRisk/commCodeCategories',
    method: 'GET',
    authorised: true,
  });
  return data;
};

export const postIpaffsCategories = async (payload) => {
  const response = await backendFetch({
    url: 'v2/ipaffsRisk/commCodeCategories',
    method: 'POST',
    options: { body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } },
  });
  return response;
};

export const postOrderForms = async (data) => {
  const response = await backendFetch({
    url: 'v2/orderform',
    method: 'POST',
    options: { body: data },
  });
  return response.data;
};

export const getEPOOrderForms = async (loadId) => {
  const documentResponse = await backendFetch({
    url: `v2/EPO/orderForm`,
    params: { loadId },
    method: 'GET',
  });
  return documentResponse.data;
};

export const postDescartesDocumentSubmit = async ({ data, type }) => {
  const urls = {
    SDI: 'v2/descartes/sdi',
    SFD: 'v2/descartes/sfd',
    FFD: 'v2/descartes/ffd',
    C21: 'v2/descartes/c21',
    EAD: 'v2/descartes/ead',
  };

  const url = urls[type];
  if (!url) {
    throw new Error('no url for that type in postDescartesDocumentSubmit');
  }

  const response = await backendFetch({
    url,
    method: 'POST',
    options: { body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } },
  });

  return response.data;
};

export const postThymeITDocumentSubmit = async ({ data, type }) => {
  const urls = {
    IE_IMPORT: 'v2/thymeit/import',
    IE_EXPORT: 'v2/thymeit/export',
  };

  const url = urls[type];
  if (!url) {
    throw new Error('no url for that type in postThymeITDocumentSubmit');
  }

  const response = await backendFetch({
    url,
    method: 'POST',
    options: { body: JSON.stringify(data), headers: { 'Content-Type': 'application/json' } },
  });

  return response.data;
};

export const duplicateLoadCheck = async (payload) => {
  const response = await backendFetch({
    url: `v2/newload/duplicatecheck`,
    options: { body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
  return response.data;
};

export const getExchangeRate = async (currency, date) => {
  const response = await backendFetch({
    url: `v2/newload/exchangeRate`,
    params: { currency, ...(date ? { date } : {}) },
    method: 'GET',
  });
  return response.data;
};

export const getNeeNorVATDetails = async (id) => {
  const response = await backendFetch({
    url: `v2/newload/qaVat`,
    params: { id },
    method: 'GET',
  });
  return response.data;
};

export const postListLoadStatus = async (payload) => {
  const documentResponse = await backendFetch({
    url: 'v2/listload/status',
    options: { body: JSON.stringify([...payload]), headers: { 'Content-Type': 'application/json' } },
    method: 'POST',
  });
  return documentResponse.data;
};

export const getPortProcesses = async () => {
  const { data } = await backendFetch({
    url: 'v2/newload/portprocessdropdown',
    method: 'GET',
    authorised: true,
  });
  return data;
};

export const postSupplementaryUnits = async (items, isGBImport) => {
  const documentResponse = await backendFetch({
    url: 'v2/newload/commoditySupplementaryUnits',
    options: {
      body: JSON.stringify({
        items: items,
        gbImport: isGBImport,
      }),
      headers: { 'Content-Type': 'application/json' },
    },
    method: 'POST',
  });
  return documentResponse.data;
};

// Returns a list of all possible subtasks - used to populate list in the Add Subtask modal
export const getAllSubtasks = async () => {
  const response = await backendFetch({
    url: 'v2/listload/subTask',
    method: 'GET',
  });
  return response.data ?? response;
};

// Adds a subtask to a load
export const addSubtask = async (loadId, subTaskId) => {
  const documentResponse = await backendFetch({
    url: 'v2/listload/subTask',
    options: {
      body: JSON.stringify({
        newLoadId: parseInt(loadId),
        subTaskId: parseInt(subTaskId),
      }),
      headers: { 'Content-Type': 'application/json' },
    },
    method: 'POST',
  });
  return documentResponse.data;
};

// Deletes a subtask from a load
export const deleteSubtask = async (subTaskId) => {
  const documentResponse = await backendFetch({
    url: 'v2/listload/subTask/' + subTaskId,
    method: 'DELETE',
  });
  return documentResponse.data;
};
